import { Guid } from "guid-typescript";

export class LinkedDocumentModel {
  documentGuid: Guid | undefined;
  documentUrl: string = '';
  fileName: string = '';
  borrowerNote: string | undefined;
  documentTypeId: string | undefined;
  dateInserted: string | undefined;
  insertedByName: string | undefined;
  docFileType: DocFileType | undefined;
}

export class BorrowerDocumentModel {

  docFileId: number | undefined;
  losDocFileId: string | undefined;
  guid: Guid | any;
  borrowerId: number | undefined;
  documentTypeId: number | undefined;
  note: string | undefined;
  borrowerNote: string | undefined;
  condition: boolean | undefined;
  replacementValuesJson: string | undefined;
  title: string | undefined;
  fileName: string = '';
  mimeType: string | undefined;
  fileData: string | undefined;
  exportDate: Date | undefined;
  active: boolean | undefined;
  companyId: number | undefined;
  insertedBy: string = '';
  dateInserted: Date = new Date();
  updatedBy: string | undefined;
  dateUpdated: Date | undefined;

  constructor() {
  }
}

export enum DocFileType {
  Normal = "Normal",
  EsignedLoanDoc = "EsignedLoanDoc",
  EsignedLoanDocCombined = "EsignedLoanDocCombined",
  EsignedLosLoanDoc = "EsignedLosLoanDoc",
  EsignedLosLoanDocCombined = "EsignedLosLoanDocCombined",
  EsignedCertOfCompletion = "EsignedCertOfCompletion"
}
